module.exports = __webpack_public_path__ + "img/PFS-Now-part-of-GXO-Logo.4d406762.svg";